// Country code to country name mapping
import { config } from '../../client/config';

const COUNTRY_NAMES: Record<string, string> = {
  AT: 'Austria',
  BE: 'Belgium',
  BR: 'Brazil',
  CA: 'Canada',
  CH: 'Switzerland',
  DE: 'Germany',
  ES: 'Spain',
  FI: 'Finland',
  GB: 'United Kingdom',
  IE: 'Ireland',
  IT: 'Italy',
  LT: 'Lithuania',
  NL: 'Netherlands',
  PT: 'Portugal',
  US: 'United States',
  IL: 'Israel',
  RU: 'Russia',
  FR: 'France',
  PL: 'Poland',
  AU: 'Australia',
  JP: 'Japan',
  KR: 'South Korea',
  CN: 'China',
  IN: 'India',
  SE: 'Sweden',
  NO: 'Norway',
  DK: 'Denmark',
  MX: 'Mexico',
  AR: 'Argentina',
  CL: 'Chile',
  CO: 'Colombia',
  PE: 'Peru',
  VE: 'Venezuela',
  UY: 'Uruguay',
  EC: 'Ecuador',
  BO: 'Bolivia',
  PY: 'Paraguay',
  GY: 'Guyana',
  SR: 'Suriname',
  GF: 'French Guiana',
  TR: 'Turkey',
  GR: 'Greece',
  CY: 'Cyprus',
  MT: 'Malta',
  LU: 'Luxembourg',
  CZ: 'Czech Republic',
  SK: 'Slovakia',
  HU: 'Hungary',
  SI: 'Slovenia',
  HR: 'Croatia',
  RS: 'Serbia',
  BA: 'Bosnia and Herzegovina',
  MK: 'North Macedonia',
  AL: 'Albania',
  ME: 'Montenegro',
  BG: 'Bulgaria',
  RO: 'Romania',
  MD: 'Moldova',
  UA: 'Ukraine',
  BY: 'Belarus',
  EE: 'Estonia',
  LV: 'Latvia',
  IS: 'Iceland',
  FO: 'Faroe Islands',
  AD: 'Andorra',
  MC: 'Monaco',
  SM: 'San Marino',
  VA: 'Vatican City',
  LI: 'Liechtenstein',
  ZA: 'South Africa',
  EG: 'Egypt',
  NG: 'Nigeria',
  KE: 'Kenya',
  MA: 'Morocco',
  TN: 'Tunisia',
  DZ: 'Algeria',
  LY: 'Libya',
  SD: 'Sudan',
  ET: 'Ethiopia',
  UG: 'Uganda',
  TZ: 'Tanzania',
  RW: 'Rwanda',
  BW: 'Botswana',
  NA: 'Namibia',
  ZM: 'Zambia',
  ZW: 'Zimbabwe',
  MZ: 'Mozambique',
  MW: 'Malawi',
  SZ: 'Eswatini',
  LS: 'Lesotho',
  NZ: 'New Zealand',
  FJ: 'Fiji',
  PG: 'Papua New Guinea',
  SB: 'Solomon Islands',
  VU: 'Vanuatu',
  NC: 'New Caledonia',
  PF: 'French Polynesia',
  WS: 'Samoa',
  TO: 'Tonga',
  KI: 'Kiribati',
  TV: 'Tuvalu',
  NR: 'Nauru',
  PW: 'Palau',
  FM: 'Micronesia',
  MH: 'Marshall Islands',
  TH: 'Thailand',
  VN: 'Vietnam',
  MY: 'Malaysia',
  SG: 'Singapore',
  ID: 'Indonesia',
  PH: 'Philippines',
  BN: 'Brunei',
  KH: 'Cambodia',
  LA: 'Laos',
  MM: 'Myanmar',
  BD: 'Bangladesh',
  PK: 'Pakistan',
  AF: 'Afghanistan',
  LK: 'Sri Lanka',
  MV: 'Maldives',
  BT: 'Bhutan',
  NP: 'Nepal',
  IR: 'Iran',
  IQ: 'Iraq',
  SY: 'Syria',
  LB: 'Lebanon',
  JO: 'Jordan',
  SA: 'Saudi Arabia',
  AE: 'United Arab Emirates',
  QA: 'Qatar',
  BH: 'Bahrain',
  KW: 'Kuwait',
  OM: 'Oman',
  YE: 'Yemen',
  AM: 'Armenia',
  AZ: 'Azerbaijan',
  GE: 'Georgia',
  KZ: 'Kazakhstan',
  UZ: 'Uzbekistan',
  TM: 'Turkmenistan',
  TJ: 'Tajikistan',
  KG: 'Kyrgyzstan',
  MN: 'Mongolia',
};

// Country code to flag emoji mapping
const COUNTRY_FLAGS: Record<string, string> = {
  AT: '🇦🇹',
  BE: '🇧🇪',
  BR: '🇧🇷',
  CA: '🇨🇦',
  CH: '🇨🇭',
  DE: '🇩🇪',
  ES: '🇪🇸',
  FI: '🇫🇮',
  GB: '🇬🇧',
  IE: '🇮🇪',
  IL: '🇮🇱',
  IT: '🇮🇹',
  LT: '🇱🇹',
  NL: '🇳🇱',
  PT: '🇵🇹',
  US: '🇺🇸',
  RU: '🇷🇺',
  FR: '🇫🇷',
  PL: '🇵🇱',
  AU: '🇦🇺',
  JP: '🇯🇵',
  KR: '🇰🇷',
  CN: '🇨🇳',
  IN: '🇮🇳',
  SE: '🇸🇪',
  NO: '🇳🇴',
  DK: '🇩🇰',
  MX: '🇲🇽',
  AR: '🇦🇷',
  CL: '🇨🇱',
  CO: '🇨🇴',
  PE: '🇵🇪',
  VE: '🇻🇪',
  UY: '🇺🇾',
  EC: '🇪🇨',
  BO: '🇧🇴',
  PY: '🇵🇾',
  GY: '🇬🇾',
  SR: '🇸🇷',
  GF: '🇬🇫',
  TR: '🇹🇷',
  GR: '🇬🇷',
  CY: '🇨🇾',
  MT: '🇲🇹',
  LU: '🇱🇺',
  CZ: '🇨🇿',
  SK: '🇸🇰',
  HU: '🇭🇺',
  SI: '🇸🇮',
  HR: '🇭🇷',
  RS: '🇷🇸',
  BA: '🇧🇦',
  MK: '🇲🇰',
  AL: '🇦🇱',
  ME: '🇲🇪',
  BG: '🇧🇬',
  RO: '🇷🇴',
  MD: '🇲🇩',
  UA: '🇺🇦',
  BY: '🇧🇾',
  EE: '🇪🇪',
  LV: '🇱🇻',
  IS: '🇮🇸',
  FO: '🇫🇴',
  AD: '🇦🇩',
  MC: '🇲🇨',
  SM: '🇸🇲',
  VA: '🇻🇦',
  LI: '🇱🇮',
  ZA: '🇿🇦',
  EG: '🇪🇬',
  NG: '🇳🇬',
  KE: '🇰🇪',
  MA: '🇲🇦',
  TN: '🇹🇳',
  DZ: '🇩🇿',
  LY: '🇱🇾',
  SD: '🇸🇩',
  ET: '🇪🇹',
  UG: '🇺🇬',
  TZ: '🇹🇿',
  RW: '🇷🇼',
  BW: '🇧🇼',
  NA: '🇳🇦',
  ZM: '🇿🇲',
  ZW: '🇿🇼',
  MZ: '🇲🇿',
  MW: '🇲🇼',
  SZ: '🇸🇿',
  LS: '🇱🇸',
  NZ: '🇳🇿',
  FJ: '🇫🇯',
  PG: '🇵🇬',
  SB: '🇸🇧',
  VU: '🇻🇺',
  NC: '🇳🇨',
  PF: '🇵🇫',
  WS: '🇼🇸',
  TO: '🇹🇴',
  KI: '🇰🇮',
  TV: '🇹🇻',
  NR: '🇳🇷',
  PW: '🇵🇼',
  FM: '🇫🇲',
  MH: '🇲🇭',
  TH: '🇹🇭',
  VN: '🇻🇳',
  MY: '🇲🇾',
  SG: '🇸🇬',
  ID: '🇮🇩',
  PH: '🇵🇭',
  BN: '🇧🇳',
  KH: '🇰🇭',
  LA: '🇱🇦',
  MM: '🇲🇲',
  BD: '🇧🇩',
  PK: '🇵🇰',
  AF: '🇦🇫',
  LK: '🇱🇰',
  MV: '🇲🇻',
  BT: '🇧🇹',
  NP: '🇳🇵',
  IR: '🇮🇷',
  IQ: '🇮🇶',
  SY: '🇸🇾',
  LB: '🇱🇧',
  JO: '🇯🇴',
  SA: '🇸🇦',
  AE: '🇦🇪',
  QA: '🇶🇦',
  BH: '🇧🇭',
  KW: '🇰🇼',
  OM: '🇴🇲',
  YE: '🇾🇪',
  AM: '🇦🇲',
  AZ: '🇦🇿',
  GE: '🇬🇪',
  KZ: '🇰🇿',
  UZ: '🇺🇿',
  TM: '🇹🇲',
  TJ: '🇹🇯',
  KG: '🇰🇬',
  MN: '🇲🇳',
};

/**
 * Gets the two-letter country code from the geo object
 * @returns {string | undefined} The two-letter country code or undefined if not available
 */
export const getCountryCode = (): string | undefined => {
  return config.geo;
};
/**
 * Gets the country name from the geo object
 * @returns {string} The country name, country code as fallback, or 'your country' if not available
 */
export const getCountryName = (): string => {
  const countryCode = getCountryCode();
  return countryCode ? COUNTRY_NAMES[countryCode] || countryCode : 'your country';
};

/**
 * Gets the flag emoji for the current country
 * @returns {string | undefined} The flag emoji for the country or undefined if not available
 */
export const getCountryFlag = (): string | undefined => {
  const countryCode = getCountryCode();
  return countryCode ? COUNTRY_FLAGS[countryCode] : undefined;
};

/**
 * Checks if the accept payments widget should be shown
 * @param isFeatureFlagEnabled - Whether the ShowPaymentWidget feature flag is enabled
 * @param paymentAcceptedCountries - Array of country codes that natively support payments
 * @returns {boolean} Whether to show the accept payments widget
 */
export const shouldShowAcceptPayments = (paymentAcceptedCountries: string[] = []): boolean => {
  const countryCode = getCountryCode();

  // Show if country is in the accepted countries list
  if (countryCode && paymentAcceptedCountries.includes(countryCode)) {
    return true;
  }

  return false;
};
